/**
 * Two-series categorical palette, validated for colour-vision deficiency and
 * contrast against the light dashboard surface (worst adjacent pair ΔE 32.1
 * protan, 36.2 normal; both ≥ 3:1 contrast).
 *
 * VISITORS is the brand amber darkened — #FCA311 itself sits above the
 * lightness band and only reaches 1.97:1 on white, so it fails as a mark colour
 * even though it is right for a logo.
 */
export const SERIES_COLORS = {
  visitors: "#C97A0E",
  pageviews: "#1B6EF3",
} as const;

export const RANGE_OPTIONS = [
  { label: "7 days", days: 7 },
  { label: "30 days", days: 30 },
  { label: "90 days", days: 90 },
] as const;

export const SITE_OPTIONS = [
  { label: "Both sites", value: null },
  { label: "Marketplace", value: "marketplace" },
  { label: "Portal", value: "portal" },
] as const;

// The estimator's internal page names are camelCase; these are what a person
// reading the funnel should see.
export const ESTIMATOR_STEP_LABELS: Record<string, string> = {
  addressPage: "Address",
  chargerLocation: "Charger location",
  vehicleType: "Vehicle",
  homeSetup: "Home setup",
  powerAccess: "Power access",
  preferences: "Preferences",
  contactInformation: "Contact info",
  reviewDetails: "Review",
  selectEstimate: "Select estimate",
  quote: "Quote",
};
